/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, TemplateRef, viewChild } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { FlagComponent } from '../../../../flag/flag.component';

@Component({
  selector: 'bn-web-ui-optgroup-select-template',
  templateUrl: './opt-group-select-template.component.html',
  imports: [NgTemplateOutlet, UpperCasePipe, FaIconComponent, FlagComponent],
})
export class OptgroupSelectTemplateComponent {
  readonly optgroupTemplate = viewChild.required<TemplateRef<any>>('optgroupTemplate');
}
